import dayjs from "dayjs";
import duration from 'dayjs/plugin/duration'
dayjs.extend(duration);

/**Remove os espaços entre as palavras */
export function removerEspacos(str: string): string {
    return String(str).replace(/\s+/g, '');
}

/**retorna a ultima posição de um array
* 
* (opcional) pode passar um segundo argumento `posicao` para retornar a posicao do array
* 
* (padrão) pode passar um segundo argumento `valor` para retornar o valor da posicao 
*/
export function ultimaPosicao(array: any[], retornar?: 'posicao' | 'valor') {
    if (retornar === 'posicao') {
        return array?.slice(-1);
    }
    return array?.slice(-1)?.[0];
}


/**Remove os acentos de uma string */
export function removerAcentos(str: string): string {
    return String(str).normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}


export function leadZero(numero: string | number) {
    return String(numero)?.padStart(2, '0');
}

/**retorna o próprio index fornecido, apenas para eviar warning do SonarQube */
export function gerarKey(index: number): number {
    return index
}


/**Deixa que apenas números sejam digitados */
export const apenasNumeros = value => {
    const str = String(value).trim();
    const isNegative = str.startsWith('-');
    const numericPart = str.replace(/\D/g, '');
    return isNegative ? `-${numericPart}` : numericPart;
};
// export const apenasNumeros = value => {
//     return String(value)?.replace(/\D/g, '') ?? value;
// }

export const apenasNumerosDecimais = (value: string | number) => {
    const str = String(value).trim();

    // Verifica se é negativo
    const isNegative = str.startsWith('-');

    // Remove tudo que não for número ou ponto/virgula decimal
    // Permite apenas o primeiro separador decimal (ponto ou virgula)
    let separatorFound = false;
    const numericPart = str
        .replace(/[^0-9.,]/g, '')
        .replace(/[.,]/g, (match) => {
            if (!separatorFound) {
                separatorFound = true;
                return match;
            }
            return '';
        });

    // Se começar com separador, adiciona o zero à esquerda
    const result = (numericPart.startsWith('.') || numericPart.startsWith(','))
        ? '0' + numericPart
        : numericPart;

    return isNegative ? `-${result}` : result;
};


/**Converte um array de `strings` para um array de `números` */
export function parseArrayNumeros(array: string[] | number[]): number[] {
    return (array ?? [])?.map(item => Number(item));
}

/**Converte um array de `números` para um array de `strings` */
export function parseArrayStrings(array: number[] | string[]) {
    return (array ?? [])?.map(item => String(item));
}



export const mascaraData = (value: string) => {
    return String(value)
        .replace(/\D/g, '') // substitui qualquer caractere que não seja número por nada
        .slice(0, 8) // limita a 8 caracteres numéricos (ddMMyyyy)
        .replace(/(\d{2})(\d)/, '$1/$2') // adiciona `/` após 2 números digitados
        .replace(/(\d{2})(\d)/, '$1/$2'); // adiciona `/` após 2 números digitados na sequência
};
/**Arredonda um numero `decimal` para `inteiro` 
 * 
 * tipos: 
 * 
 * `auto (padrão):` Arredonda o número para o decimal mais perto
 * 
 * exemplo: `5.1 = 5`, `5.7 = 6`
 * 
 * 
 * `up:` Arredonda o número pra cima
 * 
 * exemplo: `5.1 = 6`, `5.7 = 6`
 * 
 * `down:` Arredonda o número pra baixo
 * 
 * exemplo: `5.1 = 5`, `5.7 = 5`
 * 
*/
export function arredondarNumero(value: number, type?: 'auto' | 'up' | 'down') {
    if (type === 'up') {
        return Math.ceil(value);
    }
    if (type === 'down') {
        return Math.floor(value);
    }

    return Math.round(value);
}


export const formatarValor = (valor: number): string => {
    const valorArredondado = Number(valor).toFixed(2);
    const partes = valorArredondado.split('.');
    const inteiro = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    const decimal = partes[1] ? ',' + partes[1] : '';
    return inteiro + decimal + ' ha';
}


/**remove `amp;` e subistitui por `""` (aspas) */
export function substituirAsc(str: string): string {

    let remove = String(str)?.replace(/quot;|&amp;/g, '"');
    let fraseCorrigida = remove.replace(/amp;+/g, "");


    return fraseCorrigida ?? str;
}

export function maskCNPJ(cnpj) {
    if (!cnpj) return ""
    cnpj = cnpj.replace(/\D/g, "");

    cnpj = cnpj.replace(/^(\d{2})(\d)/, "$1.$2");
    cnpj = cnpj.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
    cnpj = cnpj.replace(/\.(\d{3})(\d)/, ".$1/$2");
    cnpj = cnpj.replace(/(\d{4})(\d)/, "$1-$2");

    return cnpj;
}


export const convertSegundosParaHora = (segundos: number) => {
    return dayjs.duration(segundos, 'seconds').format('HH:mm:ss')
}


export const mascaraHectares = value => {
    const apenasNumeros = String(value).replace(/\D/g, '');

    if (apenasNumeros.length === 0) return '';
    if (apenasNumeros.length === 1) return `0.${apenasNumeros}`;
    if (apenasNumeros.length === 2) return `.${apenasNumeros}`;
    if (apenasNumeros.length === 5) return apenasNumeros?.[0] === '0' ? `${(apenasNumeros?.slice?.(1))?.replace(/^(\d+)(\d{2})$/, '$1.$2')}` : `${apenasNumeros.replace(/^(\d+)(\d{2})$/, '$1.$2')}`;

    return apenasNumeros.replace(/^(\d+)(\d{2})$/, '$1.$2');
};
// export const mascaraHectares = value => {
//     const str = String(value).replace(/\D/g, '');

//     return str.replace(/(\d{2})$/, '.$1');
// };

export const NumberArea = value => {
    let conv = Number(mascaraHectares(value))
    return conv;
};

/**
 * Formata um valor numérico para o padrão monetário pt-BR (separador de milhares e duas casas decimais).
 * Entrada aceita: number | string (ex.: "1234.5" ou "1.234,50" será normalizado).
 * Retorno: string formatada, ou string vazia para entradas inválidas.
 */
export function convertMilhar(value: number | string | null | undefined): string {
    if (value === null || value === undefined) return '';

    // Normaliza string para número: aceita "1.234,56" ou "1234.56" ou "1234"
    let numeric: number;
    if (typeof value === 'string') {
        // Remove espaços
        const trimmed = value.trim();
        if (trimmed === '') return '';

        // Se string contém vírgula assume-se formato pt-BR; substitui separador de milhar e transforma vírgula em ponto
        if (trimmed.includes(',')) {
            // Remove pontos de milhar e troca vírgula decimal por ponto
            const normalized = trimmed.replace(/\./g, '').replace(',', '.');
            numeric = Number(normalized);
        } else {
            // Tenta parse direto (ponto decimal)
            numeric = Number(trimmed);
        }
    } else {
        numeric = value;
    }

    if (!isFinite(numeric) || Number.isNaN(numeric)) return '';

    // Usa Intl.NumberFormat para garantir comportamento consistente e regras de arredondamento corretas
    const formatter = new Intl.NumberFormat('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });

    // Garantir arredondamento para 2 casas decimais
    // (Intl já faz, mas forçamos a precisão evitando imprecisões binárias)
    const rounded = Math.round((numeric + Number.EPSILON) * 100) / 100;

    return formatter.format(rounded);
}

export const transition_default = { duration: 1, ease: [0, 0.71, 0.2, 1.01], exit: { duration: 0.1, ease: [0, 1.21, 0.77, 0.91] } }


export function numeroMilhar(valor: number | string) {
    const valor_formatado = Number(valor);

    return new Intl.NumberFormat('pt-BR', {
        minimumFractionDigits: valor_formatado % 1 === 0 ? 0 : 2,
        maximumFractionDigits: 2
    }).format(valor_formatado);
}